import { environment } from '../../../../environments/environment';
import { User } from '../../../shared/models';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Address } from '../../../shared/models/adress.model';
import { DataTableParams, DataTable, DataTableTranslations } from 'angular-datatables-all-versions';
import { DonationService } from '../../../shared/services/donation.service';
import { PotService } from '../../../shared/services/pot.service';
import { Donation } from 'app/shared/models/jackpot.interface';
import { ToastyService } from 'ng2-toasty';
import { UserRoleEnum } from '../../../shared/common/user-role.enum';

@Component({
  selector: 'app-students-for-impact-details',
  templateUrl: './students-for-impact-details.component.html',
  styleUrls: ['./students-for-impact-details.component.scss']
})
export class StudentsForImpactDetailsComponent implements OnInit {

  public isPrivate = false;
;
  // public toastyService: ToastyService;

  public translations = <DataTableTranslations>{
    indexColumn: 'Num.',
    expandColumn: 'Infos.',
    selectColumn: 'Sélectionner',
    paginationLimit: 'Max.',
    paginationText: 'Résultats: {from} - {to} / {total}',
    paginationTotalPages: '/'
  }

  public site_url: string;
  public user: User;
  public address: Address;
  public amount_collected = 0;
  public amount_donated = 0;
  public amount_service_fee = 0;

  public potsCount = 0;
  public potsFiltered: any[] = [];

  public donationsCount = 0;
  public donationsFiltered: any[] = [];
  public limits = [8, 16];

  constructor(private route: ActivatedRoute, private router: Router, private donationService: DonationService,
              private potService: PotService, private toastyService: ToastyService) {
    this.site_url = environment.base_url;
    this.user = this.route.snapshot.data['user'] || ({ role: { id: null, name: null } } as User);
    if (!this.user || !this.user.id) {
      this.toastyService.error({
        title: 'Attention',
        msg: 'Impossible de charger les détails de l’utilisateur.',
        showClose: true,
        timeout: 5000,
        theme: 'bootstrap',
      });
      this.router.navigate(['/students-for-impact']);
      return;
    }
    this.isPrivate = !!(this.user.role && UserRoleEnum.PRIVATE === this.user.role.id);
  }

  ngOnInit() {
  }

  reload(params: DataTableParams, type: string): void {
    if ('POT' === type.toUpperCase()) {
      this.potService.fetchByUser(this.user.id, params).subscribe(
        data => {
          console.log(data);
          this.potsFiltered = data.pots;
          this.potsCount = data.total;

          data.pots.forEach(pot => {
            this.amount_collected += Number(pot.amount);
          });
        }
      )
    } else {
      this.donationService.fetchByUser(this.user.id, params).subscribe(
        data => {
          this.donationsFiltered = data.donations;
          this.donationsCount = data.total;

          data.donations.forEach(donation => {
            this.amount_donated += Number(donation.amount);
            this.amount_service_fee += Number(donation.service_fee);
          });
        }
      )
    }
  }

  setDonationVisibility(donation: Donation){
    donation.is_visible = !donation.is_visible;
    // let donation_to_update = Object.assign({}, donation);
    let donation_to_update = { id: donation.id, is_visible: donation.is_visible};

    this.donationService.updateAttributes(donation_to_update).subscribe(data => {
        this.toastyService.success({
          title: 'Succès',
          msg: 'La visibilité du don a été mise à jour.',
          showClose: true,
          timeout: 5000,
          theme: 'bootstrap',
        });
      },
    () => this.toastyService.error({
      title: 'Attention',
      msg: 'Une erreur s\'est produite, reessayer plus tard',
      showClose: true,
      timeout: 5000,
      theme: 'bootstrap',
    }));

  }

  setUserVisibility(donation: Donation){
    donation.is_anonymous = !donation.is_anonymous;
    let donation_to_update = { id: donation.id, is_anonymous: donation.is_anonymous};

    this.donationService.updateAttributes(donation_to_update).subscribe(data => {
        this.toastyService.success({
          title: 'Succès',
          msg: 'La visibilité de l\'utilisateur a été mise à jour.',
          showClose: true,
          timeout: 5000,
          theme: 'bootstrap',
        });
      },
    () => this.toastyService.error({
      title: 'Attention',
      msg: 'Une erreur s\'est produite, reessayer plus tard',
      showClose: true,
      timeout: 5000,
      theme: 'bootstrap',
    }));
  }

  public stringifyAddress(...inputs: string[]): string {
    let result = '';
    inputs.forEach(input => {
      if (input) {
        result += result ? ', ' + input : input;
      }
    });
    return result;
  }
  
  isStillValid(dateString: string): number {
    const today = new Date();
    const alertDate = new Date(today.setDate(today.getDate() - 10));
    const date = new Date(dateString);
    if (date >= today) {
      return 1;
    } else if (date > alertDate) {
      return 2;
    } else {
      return 0;
    }
  }
}
